import React from 'react';

const StarIcon = () => (
    <svg className="w-5 h-5 text-[#FDB241]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
);

const TestimonialCard = ({ name, role, image, testimonial, link }) => (
    <a href={link} className="block p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 mx-auto">
        <div className="flex flex-col h-full">
            <div className="flex items-center space-x-1 mb-4">
                {[...Array(5)].map((_, index) => (
                    <StarIcon key={index} />
                ))}
            </div>

            <blockquote className="flex-1">
                <p className="text-lg leading-relaxed text-gray-900">{testimonial}</p>
            </blockquote>

            {/* <div className="flex items-center mt-6">
                <img className="w-16 h-16 rounded-full object-cover" src={image} alt={name} />
                <div className="ml-4">
                    <p className="text-base font-semibold text-gray-900">{name}</p>
                    <p className="text-sm text-gray-600">{role}</p>
                </div>
            </div> */}
        </div>
    </a>
);

const TestimonialsSection = () => {
    return (
      <section className="py-16 bg-black">
        <div className="container mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 font-bold text-center mb-12 text-orange-700">
            Client Feedback on Mindspark Revolutions
          </h2>
          <p className="text-center text-orange-700 mt-4">
            Our clients love what we do. Here's what they have to say.
          </p>
          <div className="relative grid grid-cols-1 gap-6 mx-auto md:grid-cols-2 lg:grid-cols-3 lg:gap-10 max-w-5xl mt-10">
            <TestimonialCard
              testimonial="Mindspark Revolutions transformed our business with their cutting-edge solutions. Their team is professional, dedicated, and always goes the extra mile."
              link="#"
            />
            <TestimonialCard
              testimonial="The innovative approach of Mindspark Revolutions brought new energy to our digital marketing strategies. Their work is unparalleled, and the results speak for themselves."
              link="#"
            />
            <TestimonialCard
              testimonial="Partnering with Mindspark Revolutions was one of the best decisions we've made. Their design thinking and user-focused approach have elevated our product to new heights."
              link="#"
            />
          </div>
        </div>
      </section>
    );
};

export default TestimonialsSection;
